import { firebase, firestore } from '../utilities/firebase'
import { errorOfType, errorTypes } from '../utilities/Errors'
import removeUndefined from '../utilities/Data/removeUndefined'
import maybe from '../utilities/maybe'
import undefinedToDeletes from '../utilities/Data/undefinedToDeletes'

const pruneKit = (kit) => {
	const newKit = {
		...kit,
		items: (kit.items && kit.items.map(kItem => ({
			colourName: kItem.colourName,
			itemKey: kItem.itemKey
		})))
	}

	delete newKit.own
	delete newKit.want
	delete newKit.fullName

	return newKit
}

const setKit = async ({ kitDraft }) => {
	try {
		const kit = removeUndefined(undefinedToDeletes(pruneKit(kitDraft)))
		let kitId = kit.kitId
		const isCreate = !kitId
		const kitColl = firestore.collection('kits')
		const kitDocRef = kitId ? kitColl.doc(kitId) : kitColl.doc()
		kitId = kitDocRef.id

		await kitDocRef.set({
			...kit,
			kitId, // ensure the kitId is written
			...maybe({ createdTimestamp: firebase.firestore.FieldValue.serverTimestamp() }, isCreate),
			modifiedTimestamp: firebase.firestore.FieldValue.serverTimestamp()
		}, { merge: true })

		return { kitId }
	} catch (exception) {
		throw errorOfType(errorTypes.UNKNOWNERROR, { kitDraft }, exception)
	}
}

export default setKit



// WEBPACK FOOTER //
// ./src/dataservices/setKit.js